/**
 *  Validate username to allow only letters, numbers, dashes and dots
 * @param  username string
 * @returns boolean
 */
export const validateUsername = (username: string): boolean => {
  return /^[A-Za-z0-9_.]+$/.test(username)
}
